import React, { useState, useEffect, useMemo } from "react";
import { Button, Col, Form, Row } from 'react-bootstrap';
import { navigate } from 'gatsby';
import 'react-phone-input-2/lib/style.css';
import axios from 'axios';
import { useFormik } from 'formik';
import PhoneInput from 'react-phone-input-2';
import * as Yup from 'yup';
import countryList from 'react-select-country-list'
import Select from 'react-select'

const ContactUsForm = () => {

    const [step, setStep] = useState(1);
    const [isOtherSelected, setIsOtherSelected] = useState(false);

    const [curCity, setCity] = useState()
    const [curCountry, setCountry] = useState()
    const [curRegion, setRegion] = useState()
    const [curZip, setZip] = useState()
    const [successMsg, setsuccessMsg] = useState('')
    const [disable, setDisable] = React.useState(false)
    const [isLoading, setIsLoading] = useState(false)

    // const key = 'contact_page_form'
    const getKeyByReason = (reason) => {
        switch (reason) {
            case "Mobile Money / eWallet Development":
                return 'contact_page_form_ewallet';
            case "Prepaid Cards":
                return 'contact_page_form_prepaid_cards';
            case "Cross border Payment system":
                return 'contact_page_form_ir';
            case "Merchant Solution":
                return 'contact_page_form_merchant_solution';
            default:
                return 'contact_page_form';
        }
    };
    const optionsnew = [
        "Bank",
        "Credit Union",
        "Startup",
        "Microfinance Institution",
        "Other (please specify)"
    ];
    const company_id = '60e2f262bae0d2cc386c1de4'
    const source = '60e4086c46dcd0d0eecebe8d'
    const pipeline = '5e009a3150476053816421e9'
    const apikey = '663ca52af9a52312606cbe56'
    const publickey = 'dfbc44f68977568186f53347b847953d100f92c3'
    const signature = 'a98012fbee01467f8bada975ea6358cce239e27f'
    const address = {
        countryCode: curCountry,
        regionName: curRegion,
        city: curCity,
        zip: curZip
    }

    const userCountry = address.countryCode?.toLowerCase()
    const formUrl = typeof window !== 'undefined' ? window.location.href : null

    // get prevoius url from any page and get here
    const previousUrl = typeof window !== 'undefined' ? sessionStorage.getItem('previous_url') : null;

    useEffect(() => {
        axios.get('https://ipinfo.io/json').then(result => {
            setCountry(result.data['country'])
            setRegion(result.data['region'])
            setZip(result.data['postal'])
            setCity(result.data['city'])
        })
    }, [])

    // const validationSchema = object().shape({
    //   full_name: string()
    //     .required('Name is required')
    //     .matches(/^[aA-zZ\s]+$/, 'Name is invalid'),
    //   email: string().required('Email is required').email('Email is invalid'),
    //   phone_no: string()
    //     .required('Phone number is required')
    //     .min(4, 'Mobile number is invalid'),
    //   company_name: string().required('Company name is required'),
    //   description: string().required('Message is required'),
    //   reason: string().required('Product is required'),
    //   industry: string().required('Industry is required'),
    //   license: string().required('Please select an option from the dropdown menu.'),
    //   // step - 2
    //   financial_service_license: step === 2 ? string().required('Field is required') : string(),
    //   // step-3
    //   operate_country: step === 3 ? string().required('Field is required') : string(),
    //   // step 4 - Prepaid Card
    //   card_solution_type: step === 4 ? string().required('Please select a Prepaid Card option') : string(),

    //   // step 5 - BIN
    //   bin: step === 5 ? string().required('Please select a BIN option') : string(),

    //   // step 6 - Payment Processor
    //   describes_your_organization: step === 6 ? string().required('Please select a Payment Processor') : string(),

    //   // step 7 - Card Volume
    //   volume: step === 7 ? string().required('Please select a Volume option') : string(),

    //   // step 8 - Corridors
    //   corridors: step === 8 ? string().required('Please select a Corridors option') : string(),

    //   // step 9 - Transaction
    //   transaction: step === 9 ? string().required('Please select a Transaction option') : string(),

    //   // step 10 - Existing Software
    //   existing_software: step === 10 ? string().required('Please select an Existing Software option') : string(),

    //   // step 11 - Current Software Issue
    //   current_software: step === 11 ? string().required('Please select a Current Software option') : string(),


    // })



    const validationSchema = (step) => {
        return Yup.object().shape({
            full_name: Yup.string()
                .required('Name is required')
                .matches(/^[a-zA-Z\s]+$/, 'Name is invalid'),

            email: Yup.string().required('Email is required').email('Email is invalid'),
            phone_no: Yup.string()
                .required('Phone number is required')
                .min(4, 'Mobile number is invalid'),
            company_name: Yup.string().required('Company name is required'),
            description: Yup.string().required('Message is required'),
            reason: Yup.string().required('Product is required'),
            transaction_volume: (step === 14 || step === 17 || step === 23) ? Yup.string().required('Field is required') : Yup.string(),
            planning_to_launch: (step === 13 || step === 18 || step === 24) ? Yup.string().required('Field is required') : Yup.string(),


            // Step-specific validations
            financial_service_license: (step === 2 || step === 15 || step === 5 || step === 19) ? Yup.string().required('Field is required') : Yup.string(),
            operate_country: (step === 3 || step === 9) ? Yup.string().required('Field is required') : Yup.string(),
            currently_operating_ewallet: step === 12 ? Yup.string().required('Field is required') : Yup.string(),
            facing_issues_ewallet: step === 12 ? Yup.string().test(
                "is-required",
                "Field is required",
                function (value) {
                    const { currently_operating_ewallet } = this.parent;
                    return !(currently_operating_ewallet === "Yes" && !value);
                }
            ) : Yup.string(),

            currently_operating_ir: step === 8 ? Yup.string().required('Field is required') : Yup.string(),
            // ir_country: step === 9 ? Yup.string().required('Field is required') : Yup.string(),
            operate_new_corridors_country: step === 10 ? Yup.string().required('Field is required') : Yup.string(),
            // remittance_services: step === 15 ? Yup.string().required('Field is required') : Yup.string(),
            facing_issues: step === 11 ? Yup.string().required('Field is required') : Yup.string(),

            card_solution_type: step === 4 ? Yup.string().required('Field is required') : Yup.string(),
            // card_issuing: step === 5 ? Yup.string().required('Please select a BIN option') : Yup.string(),

            // other_reason: (step === 6 && optionsnew === "Other (please specify)") ? Yup.string().required('Product is required') : Yup.string(),
            other_reason: step === 6
                ? Yup.string().test(
                    "is-required",
                    "Please specify a reason",
                    function (value) {
                        const { describes_your_organization } = this.parent;
                        return !(
                            ((describes_your_organization === "Other (please specify)" && step === 6))
                            && !value
                        );
                    }
                )
                : Yup.string(),
            other_reason_type_of_business: step === 21
                ? Yup.string().test(
                    "is-required",
                    "Please specify a reason",
                    function (value) {
                        const { type_of_business } = this.parent;
                        return !(
                            (
                                (type_of_business === "Other (please specify)" && step === 21))
                            && !value
                        );
                    }
                )
                : Yup.string(),

            other_reason_facing_merchant_issues: step === 25
                ? Yup.string().test(
                    "is-required",
                    "Please specify a reason",
                    function (value) {
                        const { facing_merchant_issues } = this.parent;
                        return !(facing_merchant_issues.includes("Other (please specify)") && !value);
                    }
                )
                : Yup.string(),

            other_reason_cross_border: step === 15
                ? Yup.string().test(
                    "is-required",
                    "Please specify a reason",
                    function (value) {
                        const { financial_service_license } = this.parent;
                        return !(this.parent.financial_service_license === "Yes, we have other licenses (Please specify)" && !value);
                    }
                )
                : Yup.string(),
            // other_reason: step === 6 ? Yup.string().when(["describes_your_organization", "step"], {
            //     is: (describes_your_organization, step) =>
            //         step === 6 && describes_your_organization === "Other (please specify)",
            //     then: Yup.string().required("Please specify a reason"),
            //     otherwise: Yup.string().notRequired(),
            // }) : Yup.string(),
            describes_your_organization: step === 6 ? Yup.string().required('Field is required') : Yup.string(),
            currently_have_access_to_a_bin: step === 7 ? Yup.string().required('Field is required') : Yup.string(),
            payment_processors: (step === 16 || step === 20) ? Yup.string().required('Field is required') : Yup.string(),
            // monthly_card: step === 17 ? Yup.string().required('Field is required') : Yup.string(),
            // planning_to_launch: step === 18 ? Yup.string().required('Field is required') : Yup.string(),
            // merchant
            // merchant_requirelicense: step === 19 ? Yup.string().required('Field is required') : Yup.string(),
            // merchant_acquiringsolution: (step === 20) ? Yup.string().required('Please select a merchant acquiringsolution option') : Yup.string(),
            type_of_business: step === 21 ? Yup.string().required('Field is required') : Yup.string(),
            planning_to_offer_merchants_mpos: step === 22 ? Yup.string().required('Field is required') : Yup.string(),
            // merchant_expectedtransaction: step === 23 ? Yup.string().required('Please select a merchant acquiringsolution option') : Yup.string(),
            // merchant_launch_plan: step === 24 ? Yup.string().required('Please select a merchant acquiringsolution option') : Yup.string(),
            // facing_merchant_issues: step === 25 ? Yup.string().required('Field is required') : Yup.string(),
            facing_merchant_issues: step === 25 ? Yup.array()
                .min(1, "Field is required") : Yup.array(),

        });
    };
    const handleNext = () => {
        formikLogin.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setStep((prevStep) => prevStep + 1);
            }
        });
    };
    const formikLogin = useFormik({
        initialValues: {
            full_name: '',
            other_reason: '',
            other_reason_type_of_business: '',
            other_reason_facing_merchant_issues: '',
            other_reason_cross_border: '',
            email: '',
            phone_no: '',
            company_name: '',
            skype_id: '',
            reason: '',
            description: '',
            // common
            transaction_volume: '',
            planning_to_launch: '',

            // EWALLET
            financial_service_license: '',
            operate_country: '',
            currently_operating_ewallet: '',
            facing_issues_ewallet: '',

            // PREPAID CARD
            card_solution_type: '',
            // card_issuing: '',
            describes_your_organization: '',
            currently_have_access_to_a_bin: '',
            payment_processors: '',
            // monthly_card: '',


            // IR
            currently_operating_ir: '',
            // ir_country: '',
            operate_new_corridors_country: '',
            facing_issues: '',
            // remittance_services: '',

            // Merchant Solution
            // merchant_requirelicense: '',
            // merchant_acquiringsolution: '',
            type_of_business: '',
            planning_to_offer_merchants_mpos: '',
            // merchant_expectedtransaction: '',
            // merchant_launch_plan: '',
            facing_merchant_issues: []

        },
        validationSchema: validationSchema(step),
        onSubmit: async (values, { resetForm }) => {

            const dynamicKey = getKeyByReason(values.reason);

            // if ((step === 1 && values.reason === "Mobile Money / eWallet Development")) {
            //   setStep(step + 1);
            //   return;
            // }
            // if (step === 2) {
            //   setStep(step + 1);
            //   return;
            // }

            const social_info = {
                skype_id: values.skype_id
            }

            const additional_info = {
                url: formUrl,
                product: values.reason,
                // common use
                planning_to_launch: values.planning_to_launch,
                transaction_volume: values.transaction_volume,


                // EWALLET
                financial_service_license: values.financial_service_license === "Yes, we have other licenses (Please specify)" ? values.other_reason_cross_border : values.financial_service_license,
                operate_country: formikLogin.values.operate_country,
                currently_operating_ewallet: values.currently_operating_ewallet,
                facing_issues_ewallet: values.facing_issues_ewallet,

                // IR
                currently_operating_ir: values.currently_operating_ir,
                // ir_country: values.ir_country,
                operate_new_corridors_country: values.operate_new_corridors_country,
                // remittance_services: values.remittance_services,
                facing_issues: values.facing_issues,

                // PREPAID CARD
                card_solution_type: values.card_solution_type,
                // card_issuing: values.card_issuing,
                other_reason: values.other_reason,
                other_reason_type_of_business: values.other_reason_type_of_business,
                other_reason_facing_merchant_issues: values.other_reason_facing_merchant_issues,
                other_reason_cross_border: values.other_reason_cross_border,
                describes_your_organization: values.describes_your_organization === "Other (please specify)" ? values.other_reason : values.describes_your_organization,
                currently_have_access_to_a_bin: values.currently_have_access_to_a_bin,
                payment_processors: values.payment_processors,
                // monthly_card: values.monthly_card,
                // planning_to_launch: values.planning_to_launch,

                // Merchant Solution
                // merchant_requirelicense: values.payment_processors,
                // merchant_acquiringsolution: values.merchant_acquiringsolution,
                type_of_business: values.type_of_business === "Other (please specify)" ? values.other_reason_type_of_business : values.type_of_business,
                planning_to_offer_merchants_mpos: values.planning_to_offer_merchants_mpos,
                // merchant_expectedtransaction: values.merchant_expectedtransaction,
                // merchant_launch_plan: values.merchant_launch_plan,
                // facing_merchant_issues: values.facing_merchant_issues === "Other (please specify)" ? values.other_reason_facing_merchant_issues : values.facing_merchant_issues,
                facing_merchant_issues: values.facing_merchant_issues
                    .map((issue) =>
                        issue === "Other (please specify)" ? `${issue}: ${values.other_reason_facing_merchant_issues}` : issue
                    )
                    .join(", "),
                // previousUrl
                previousUrl: previousUrl || "No",
            }

            const hubpost_properties = {
                // industry: values.industry,
                product_interested_in: values.reason,
                // license_status: values.license,
                source_url: formUrl,
                preivous_url: previousUrl || "No",
            }

            setDisable(true)
            setIsLoading(true)

            try {
                // let result = await fetch(
                //   'https://q0j7z0lfs5.execute-api.us-west-2.amazonaws.com/lambda-create-deal0',
                //   {
                //     method: 'POST',
                //     body: JSON.stringify({
                //       full_name: values.full_name,
                //       email: values.email,
                //       phone_no: values.phone_no,
                //       company_name: values.company_name,
                //       description: values.description,
                //       social_info,
                //       key,
                //       address,
                //       additional_info,
                //       company_id,
                //       source,
                //       pipeline,
                //       hubpost_properties,
                //       apikey,
                //       publickey,
                //       signature
                //     }),
                //     headers: { 'Content-Type': 'application/json' }
                //   }
                // )


                // let result_crm_lead = await fetch("https://lgzr1eo7fb.execute-api.us-west-2.amazonaws.com/default/crm_lead", {
                //   method: "POST",
                //   body: JSON.stringify({
                //     full_name: values.full_name,
                //     email: values.email,
                //     phone_no: values.phone_no,
                //     company_name: values.company_name,
                //     description: values.description,
                //     social_info,
                //     key,
                //     address,
                //     additional_info,
                //     company_id,
                //     source,
                //     pipeline,
                //     hubpost_properties,
                //     apikey,
                //     publickey,
                //     signature
                //   }),
                //   headers: { 'Content-Type': 'application/json' },
                // });
                let result_pms_crm_lead = await fetch("https://9cdbp7k459.execute-api.us-west-2.amazonaws.com/default/pms_crm_lead", {
                    method: "POST",
                    body: JSON.stringify({
                        full_name: values.full_name,
                        email: values.email,
                        phone_no: values.phone_no,
                        company_name: values.company_name,
                        description: values.description,
                        social_info,
                        // key,
                        key: dynamicKey,
                        address,
                        additional_info,
                        company_id,
                        source,
                        pipeline,
                        hubpost_properties,
                        apikey,
                        publickey,
                        signature
                    }),
                    headers: { 'Content-Type': 'application/json' },
                });
                let result_hubspot_lead = await fetch("https://qtjs8w6uzg.execute-api.us-west-2.amazonaws.com/default/hubspot_lead", {
                    method: "POST",
                    body: JSON.stringify({
                        full_name: values.full_name,
                        email: values.email,
                        phone_no: values.phone_no,
                        company_name: values.company_name,
                        description: values.description,
                        social_info,
                        // key,
                        key: dynamicKey,
                        address,
                        additional_info,
                        company_id,
                        source,
                        pipeline,
                        hubpost_properties,
                        apikey,
                        publickey,
                        signature
                    }),
                    headers: { 'Content-Type': 'application/json' },
                });


                // result = await result.json()

                result_pms_crm_lead = await result_pms_crm_lead.json();
                result_hubspot_lead = await result_hubspot_lead.json();

                if (result_pms_crm_lead.status === 200 || result_hubspot_lead.status === 200) {
                    // if (result_pms_crm_lead.status === 200) {
                    // setsuccessMsg("Thank you for choosing DigiPay.Guru..!");
                    setsuccessMsg(false)
                    setDisable(false)
                    setIsLoading(false)
                    navigate('/thankyou')
                    resetForm()
                } else {
                    setDisable(false)
                    setIsLoading(false)
                    setsuccessMsg('Some error occured else')
                }
            } catch (err) {
                setDisable(false)
                setIsLoading(false)
                setsuccessMsg('Some error occured catch')
            }
        }
    })


    const handleStepOneTransition = () => {
        const { reason } = formikLogin.values;
        if (["Mobile Money / eWallet Development", "Prepaid Cards", "Cross border Payment system", "Merchant Solution"].includes(reason)) {
            if (reason === "Prepaid Cards") {
                setStep(4); // Go directly to step 4 if "Prepaid Cards" is selected
            } else if (reason === "Cross border Payment system") {
                setStep(8); // Jump to step 8 for "Cross border Payment system"
            } else if (reason === "Merchant Solution") {
                setStep(19); // Jump to step 19 for "Cross border Payment system"
            } else {
                handleNext(); // Proceed to step 2 for other reasons
            }
        } else {
            formikLogin.handleSubmit(); // For any other "reason", proceed to step 2
        }
    };
    const handleStepTransition = () => {
        switch (step) {
            case 1:
                handleStepOneTransition();
                break;
            case 2:
                handleNext(); // Move from step 2 to 3
                break;
            case 3:
                setStep(12); // Move from step 3 directly to step 12
                break;
            case 4:
                setStep(5); // Move from step 4 to step 5
                break;
            case 5:
                setStep(6); // Move from step 5 to step 6
                break;
            case 6:
                setStep(7);
                break;// Move from step 6 to step 7
            case 7:
                setStep(16); // Move from step 7 to step 16
                break;
            case 8:
                // setStep(9); // Move from step 8 to step 9
                if (formikLogin.values.currently_operating_ir === "Yes") {
                    setStep(9);
                } else if (formikLogin.values.reason === "Prepaid Cards") {
                    setStep(16)
                }
                else {
                    setStep(10);
                }
                break;

            case 9:
                setStep(10); // Move from step 9 to step 10
                break;
            case 10:
                if (formikLogin.values.currently_operating_ir === "No") {
                    setStep(15); // Move to step 15 if corridors is "No"
                } else {
                    setStep(11); // Otherwise, move to step 11
                }
                break;
            case 11:
                setStep(14) // Perform API call for step 11
                break;
            case 12:
                if (formikLogin.values.currently_operating_ewallet === "No") {
                    setStep(13);
                } else {
                    setStep(14);
                }
                break;
            case 13:
                if (formikLogin.values.reason === "Prepaid Cards") {
                    // Perform API call if reason is "Prepaid Cards"
                    formikLogin.handleSubmit(); // API call at step 14

                } else {
                    setStep(14); // Otherwise, move to step 14
                }
                break;

            case 14:
                formikLogin.handleSubmit(); // API call at step 14
                break;
            case 15:
                if (formikLogin.values.currently_operating_ir === "No") {
                    setStep(13); // Move from step 15 to step 14 if corridors is "No"
                } else {
                    setStep(15); // Stay on step 15
                }
                break;
            case 16:
                setStep(17); // Move from step 16 to step 17
                break;
            case 17:
                setStep(18); // Move from step 17 to step 13
                break;
            case 18:
                // setStep(18); // Move from step 17 to step 18
                if (formikLogin.values.reason === "Prepaid Cards") {
                    // Perform API call if reason is "Prepaid Cards"
                    formikLogin.handleSubmit(); // API call at step 14

                } else {
                    formikLogin.handleSubmit();  // Otherwise, move to step 14
                }
                break;
            case 19:
                setStep(20); // Move from step 19 to step 20
                break;
            case 20:
                setStep(21); // Move from step 20 to step 21
                break;
            case 21:
                setStep(22); // Move from step 21 to step 22
                break;
            case 22:
                setStep(23); // Move from step 22 to step 23
                break;
            case 23:
                setStep(24); // Move from step 23 to step 24
                break;
            case 24:
                setStep(25); // Move from step 24 to step 25
                break;
            case 25:
                formikLogin.handleSubmit(); // Default API call
                break;
            default:
                formikLogin.handleSubmit(); // Default API call
                break;
        }
    };

    const options = useMemo(() => countryList().getData(), [])

    const changeHandler = (selectedOption) => {
        formikLogin.setFieldValue('operate_country', selectedOption.label);
    };

    const changeHandlercorridor = (selectedOption) => {
        formikLogin.setFieldValue('operate_new_corridors_country', selectedOption.label);
    };

    const { errors, touched } = formikLogin

    return (
        <>
            <Form className="contact-us-form p-4 bg-white rounded">
                {step === 1 && (
                    <>
                        <Row md={2} xs={1}>
                            <Form.Group as={Col} className={errors.full_name && touched.full_name ? "mb-3 was-validated" : "mb-3"} >
                                <Form.Label>
                                    Name <em className='text-danger'>*</em>
                                </Form.Label>
                                <Form.Control
                                    type='text'
                                    name='full_name'
                                    value={formikLogin.values.full_name}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                    placeholder='Please enter your full name'
                                    size='lg'
                                    required
                                />
                                {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                          {errors.full_name && touched.full_name
                            ? errors.full_name
                            : null}
                        </p> */}
                            </Form.Group>
                            <Form.Group as={Col} className={errors.email && touched.email ? "mb-3 was-validated" : "mb-3"} >
                                <Form.Label>
                                    Business email <em className='text-danger'>*</em>
                                </Form.Label>
                                <Form.Control
                                    type='email'
                                    name='email'
                                    value={formikLogin.values.email}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                    placeholder='example@company.com'
                                    size='lg'
                                    required
                                />
                                {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                          {errors.email && touched.email ? errors.email : null}
                        </p> */}
                            </Form.Group>
                            <Form.Group as={Col} className={errors.phone_no && touched.phone_no ? "mb-3 was-validated" : "mb-3"} >
                                <Form.Label>
                                    Phone number <em className='text-danger'>*</em>
                                </Form.Label>
                                <PhoneInput
                                    inputProps={{
                                        name: 'phone_no',
                                        required: true,
                                    }}
                                    inputClass='form-control-phone form-control-lg'
                                    containerClass='country-phone'
                                    onChange={e =>
                                        formikLogin.setFieldValue('phone_no', e)
                                    }
                                    onBlur={formikLogin.handleBlur}
                                    value={formikLogin.values.phone_no}
                                    country={userCountry ? userCountry : 'us'}
                                    countryCodeEditable={false}
                                    enableSearch={true}
                                    disableSearchIcon={true}

                                />
                                {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                          {errors.phone_no && touched.phone_no
                            ? errors.phone_no
                            : null}
                        </p> */}
                            </Form.Group>
                            <Form.Group as={Col} className={errors.company_name && touched.company_name ? "mb-3 was-validated" : "mb-3"} >
                                <Form.Label>
                                    Company name <em className='text-danger'>*</em>
                                </Form.Label>
                                <Form.Control
                                    type='text'
                                    name='company_name'
                                    value={formikLogin.values.company_name}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                    placeholder='Provide your company name'
                                    required
                                />
                                {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                          {errors.company_name && touched.company_name
                            ? errors.company_name
                            : null}
                        </p> */}

                            </Form.Group>
                            {/* <Form.Group as={Col} className='mb-3'>
                        <Form.Label>Skype Id</Form.Label>
                        <Form.Control
                          type='text'
                          name='skype_id'
                          size='lg'
                          value={formikLogin.values.skype_id}
                          onChange={formikLogin.handleChange}
                          onBlur={formikLogin.handleBlur}
                          placeholder="Enter your skype id"
                        />
                      </Form.Group> */}


                        </Row>
                        <Form.Group as={Col} className={errors.reason && touched.reason ? "mb-3 was-validated" : "mb-3"}>
                            <Form.Label>
                                Product interested in <em className='text-danger'>*</em>
                            </Form.Label>
                            <Form.Select
                                name='reason'
                                aria-label="Reason"
                                size='lg'
                                value={formikLogin.values.reason}
                                onChange={formikLogin.handleChange}
                                onBlur={formikLogin.handleBlur}
                                required
                            >
                                <option value=''>
                                    Please select
                                </option>
                                <option value='Mobile Money / eWallet Development'>
                                    Mobile Money / eWallet Development
                                </option>
                                <option value='Agency Banking'>Agency Banking</option>
                                <option value='Cross border Payment system'>
                                    Cross border Payment system
                                </option>
                                <option value='Merchant Solution'>
                                    Merchant Solution
                                </option>
                                <option value='Prepaid Cards'>
                                    Prepaid Cards
                                </option>
                                <option value='eKYC Solution'>
                                    eKYC Solution
                                </option>

                                <option value='Other'>Other</option>
                            </Form.Select>

                        </Form.Group>

                        <Form.Group className={errors.description && touched.description ? "mb-3 was-validated" : "mb-3"}>
                            <Form.Label>
                                Kindly describe your project idea <em className='text-danger'>*</em>
                            </Form.Label>
                            <Form.Control
                                as='textarea'
                                name='description'
                                size='lg'
                                value={formikLogin.description}
                                onChange={formikLogin.handleChange}
                                onBlur={formikLogin.handleBlur}
                                placeholder='Kindly provide information about the key features, integrations, users and markets'
                                rows={3}
                                required
                            />

                        </Form.Group>
                    </>
                )}
                {/* eWallet	 */}

                {step === 2 && (
                    <>

                        <div className="mb-4">
                            <h3 className="mb-3">Does your company hold a financial service license?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, we already have the required license"
                            name="financial_service_license"
                            id="option1"
                            value="Yes, we already have the required license"
                            checked={formikLogin.values.financial_service_license === "Yes, we already have the required license"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="We are in the process of obtaining the license"
                            name="financial_service_license"
                            id="option2"
                            value="We are in the process of obtaining the license"
                            checked={formikLogin.values.financial_service_license === "We are in the process of obtaining the license"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, we need guidance on licensing requirements"
                            name="financial_service_license"
                            id="option3"
                            value="No, we need guidance on licensing requirements"
                            checked={formikLogin.values.financial_service_license === "No, we need guidance on licensing requirements"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Not applicable for our region"
                            name="financial_service_license"
                            id="option4"
                            value="Not applicable for our region"
                            checked={formikLogin.values.financial_service_license === "Not applicable for our region"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                          {errors.email && touched.email ? errors.email : null}
                        </p> */}
                        {errors.financial_service_license && touched.financial_service_license && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.financial_service_license}
                            </p>
                        )}

                    </>
                )}
                {/* start */}
                {step === 3 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">In which country are you planning to operate eWallet business ?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Group className={errors.operate_country && touched.operate_country ? "mb-3 was-validated" : "mb-3"}>
                            {/* <Form.Label>
                            In which country are you planning to operate eWallet business ? <em className='text-danger'>*</em>
                          </Form.Label> */}
                            {/* <Form.Select
                            aria-label="License"
                            name='operate_country'
                            size='lg'
                            value={formikLogin.values.operate_country}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                            required
                          >
                            <option value=''>Please select country</option>
                            <option value='India'>India</option>
                            <option value='America'>America</option>
                            <option value='Africa'>Africa</option>
                          </Form.Select> */}
                            <Select
                                required
                                options={options}
                                value={options.find(option => option.value === formikLogin.values.operate_country)} // Find selected option
                                onChange={changeHandler}
                                placeholder="Select country"
                            />
                        </Form.Group>
                    </>
                )}

                {step === 12 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Are you currently operating eWallet business ?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes"
                            name="currently_operating_ewallet"
                            id="option1"
                            value="Yes"
                            checked={formikLogin.values.currently_operating_ewallet === "Yes"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}

                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No"
                            name="currently_operating_ewallet"
                            id="option2"
                            value="No"
                            checked={formikLogin.values.currently_operating_ewallet === "No"}
                            onBlur={formikLogin.handleBlur}
                            onChange={formikLogin.handleChange}
                        // onChange={(e) => {
                        //   formikLogin.handleChange(e);
                        //   if (e.target.value === "No") {
                        //     setStep(13);
                        //   }
                        // }}
                        />
                        {errors.currently_operating_ewallet && touched.currently_operating_ewallet && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.currently_operating_ewallet}
                            </p>
                        )}

                        {formikLogin.values.currently_operating_ewallet === "Yes" && (
                            <div>
                                <h3 className="h4 my-4">Are you facing any issues / problems with the existing solution?</h3>
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Complicated user interface"
                                    name="facing_issues_ewallet"
                                    id="option3"
                                    value="Complicated user interface"
                                    checked={formikLogin.values.facing_issues_ewallet === "Complicated user interface"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Inadequate security"
                                    name="facing_issues_ewallet"
                                    id="option4"
                                    value="Inadequate security"
                                    checked={formikLogin.values.facing_issues_ewallet === "Inadequate security"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Lack of scalability"
                                    name="facing_issues_ewallet"
                                    id="option5"
                                    value="Lack of scalability"
                                    checked={formikLogin.values.facing_issues_ewallet === "Lack of scalability"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Limited payment options"
                                    name="facing_issues_ewallet"
                                    id="option6"
                                    value="Limited payment options"
                                    checked={formikLogin.values.facing_issues_ewallet === "Limited payment options"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Poor integration with other systems"
                                    name="facing_issues_ewallet"
                                    id="option7"
                                    value="Poor integration with other systems"
                                    checked={formikLogin.values.facing_issues_ewallet === "Poor integration with other systems"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Poor customer support"
                                    name="facing_issues_ewallet"
                                    id="option8"
                                    value="Poor customer support"
                                    checked={formikLogin.values.facing_issues_ewallet === "Poor customer support"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Regulatory compliance issues"
                                    name="facing_issues_ewallet"
                                    id="option9"
                                    value="Regulatory compliance issues"
                                    checked={formikLogin.values.facing_issues_ewallet === "Regulatory compliance issues"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Slow response times"
                                    name="facing_issues_ewallet"
                                    id="option10"
                                    value="Slow response times"
                                    checked={formikLogin.values.facing_issues_ewallet === "Slow response times"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                <Form.Check
                                    className="mb-2"
                                    type="radio"
                                    label="Technical glitches"
                                    name="facing_issues_ewallet"
                                    id="option11"
                                    value="Technical glitches"
                                    checked={formikLogin.values.facing_issues_ewallet === "Technical glitches"}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                />
                                {formikLogin.values.currently_operating_ewallet === "Yes" &&
                                    errors.facing_issues_ewallet &&
                                    touched.facing_issues_ewallet && (
                                        <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                            {errors.facing_issues_ewallet}
                                        </p>
                                    )}
                            </div>)
                        }
                    </>
                )}
                {step === 13 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">When are you planning to launch this business?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>


                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Within 3 months"
                            name="planning_to_launch"
                            id="option1"
                            value="Within 3 months"
                            checked={formikLogin.values.planning_to_launch === "Within 3 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="3–6 months"
                            name="planning_to_launch"
                            id="option2"
                            value="3–6 months"
                            checked={formikLogin.values.planning_to_launch === "3–6 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="6–12 months"
                            name="planning_to_launch"
                            id="option3"
                            value="6–12 months"
                            checked={formikLogin.values.planning_to_launch === "6–12 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="More than a year away"
                            name="planning_to_launch"
                            id="option4"
                            value="More than a year away"
                            checked={formikLogin.values.planning_to_launch === "More than a year away"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.planning_to_launch && touched.planning_to_launch && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.planning_to_launch}
                            </p>
                        )}
                        {/* {errors.operate_country && touched.operate_country && (
                          <p className="form-text text-danger mt-2 mb-0 font-size-14">
                            {errors.operate_country}
                          </p>
                        )} */}
                    </>
                )}
                {step === 14 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">What is the expected monthly transaction volume ?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Less than 10,000 transactions"
                            name="transaction_volume"
                            id="option1"
                            value="Less than 10,000 transactions"
                            checked={formikLogin.values.transaction_volume === "Less than 10,000 transactions"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="10,000 – 50,000 transactions"
                            name="transaction_volume"
                            id="option2"
                            value="10,000 – 50,000 transactions"
                            checked={formikLogin.values.transaction_volume === "10,000 – 50,000 transactions"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="50,000 – 100,000 transactions"
                            name="transaction_volume"
                            id="option3"
                            value="50,000 – 100,000 transactions"
                            checked={formikLogin.values.transaction_volume === "50,000 – 100,000 transactions"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="More than 100,000 transactions"
                            name="transaction_volume"
                            id="option4"
                            value="More than 100,000 transactions"
                            checked={formikLogin.values.transaction_volume === "More than 100,000 transactions"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.transaction_volume && touched.transaction_volume && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.transaction_volume}
                            </p>
                        )}
                        {/* {errors.operate_country && touched.operate_country && (
                          <p className="form-text text-danger mt-2 mb-0 font-size-14">
                            {errors.operate_country}
                          </p>
                        )} */}
                    </>
                )}

                {/* Prepaid Card */}
                {step === 4 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">What type of card solution are you looking for?	</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            name="card_solution_type"
                            id="option21"
                            value="Prepaid Cards"
                            label="Prepaid Cards"
                            checked={formikLogin.values.card_solution_type === "Prepaid Cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            name="card_solution_type"
                            id="option22"
                            value="Debit Cards"
                            label="Debit Cards"
                            checked={formikLogin.values.card_solution_type === "Debit Cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            name="card_solution_type"
                            id="option23"
                            value="Fleet Cards"
                            label="Fleet Cards"
                            checked={formikLogin.values.card_solution_type === "Fleet Cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            name="card_solution_type"
                            id="option24"
                            value="Corporate Cards"
                            label="Corporate Cards"
                            checked={formikLogin.values.card_solution_type === "Corporate Cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            name="card_solution_type"
                            id="option25"
                            value="Gift Cards"
                            label="Gift Cards"
                            checked={formikLogin.values.card_solution_type === "Gift Cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.card_solution_type && touched.card_solution_type && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.card_solution_type}
                            </p>
                        )}
                    </>
                )}
                {step === 5 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Do you currently hold any licenses for offering card issuing ?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, we have a valid card issuing license"
                            id="option24"
                            name="financial_service_license"
                            value="Yes, we have a valid card issuing license"
                            checked={formikLogin.values.financial_service_license === "Yes, we have a valid card issuing license"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="We are in the process of obtaining a license"
                            id="option25"
                            name="financial_service_license"
                            value="We are in the process of obtaining a license"
                            checked={formikLogin.values.financial_service_license === "We are in the process of obtaining a license"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, we do not have a license and do not plan to obtain one"
                            id="option26"
                            name="financial_service_license"
                            value="No, we do not have a license and do not plan to obtain one"
                            checked={formikLogin.values.financial_service_license === "No, we do not have a license and do not plan to obtain one"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Not sure yet"
                            id="option27"
                            name="financial_service_license"
                            value="Not sure yet"
                            checked={formikLogin.values.financial_service_license === "Not sure yet"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.financial_service_license && touched.financial_service_license && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.financial_service_license}
                            </p>
                        )}
                    </>
                )}
                {step === 6 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Which of the following best describes your organization?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>

                        {optionsnew.map((option, index) => (
                            <Form.Check
                                key={index}
                                className="mb-2"
                                type="radio"
                                label={option}
                                id={`option${index + 27}`}
                                name="describes_your_organization"
                                value={option}
                                checked={formikLogin.values.describes_your_organization === option}
                                onChange={formikLogin.handleChange}
                                onBlur={formikLogin.handleBlur}
                            />
                        ))}

                        {/* <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Bank"
                            id="option27"
                            name="describes_your_organization"
                            value="Bank"
                            checked={formikLogin.values.describes_your_organization === "Bank"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Credit Union"
                            id="option28"
                            name="describes_your_organization"
                            value="Credit Union"
                            checked={formikLogin.values.describes_your_organization === "Credit Union"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Startup"
                            id="option29"
                            name="describes_your_organization"
                            value="Startup"
                            checked={formikLogin.values.describes_your_organization === "Startup"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Microfinance Institution"
                            id="option30"
                            name="describes_your_organization"
                            value="Microfinance Institution"
                            checked={formikLogin.values.describes_your_organization === "Microfinance Institution"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Other (please specify)"
                            id="option31"
                            name="describes_your_organization"
                            value="Other (please specify)"
                            // checked={formikLogin.values.describes_your_organization === "Other (please specify)"}
                            checked={formikLogin.values.describes_your_organization === "Other (please specify)"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        /> */}


                        {/* {formikLogin.values.describes_your_organization === "Other (please specify)" && (
                            <Form.Group as={Col} className={errors.other_reason && touched.other_reason ? "mb-3 was-validated" : "mb-3"}>
                                <Form.Control
                                    type="text"
                                    name="other_reason"
                                    value={formikLogin.values.other_reason}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                    placeholder="Please enter your reason"
                                    size="lg"
                                    required={formikLogin.values.describes_your_organization === "Other (please specify)" ? true : false}
                                />
                            </Form.Group>
                        )} */}

                        {formikLogin.values.describes_your_organization === "Other (please specify)" && (
                            <Form.Group as={Col} className={errors.other_reason && touched.other_reason ? "mb-3 was-validated" : "mb-3"}>
                                <Form.Control
                                    type="text"
                                    name="other_reason"
                                    value={formikLogin.values.other_reason}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                    placeholder="Please enter your reason"
                                    size="lg"
                                    // isInvalid={formikLogin.touched.other_reason && !!formikLogin.errors.other_reason}
                                    required

                                />
                            </Form.Group>
                        )}
                        {errors.describes_your_organization && touched.describes_your_organization && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.describes_your_organization}
                            </p>
                        )}
                    </>
                )}
                {step === 7 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Do you currently have access to a BIN for your card issuing solution?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, we have our own BIN"
                            id="option30"
                            name="currently_have_access_to_a_bin"
                            value="Yes, we have our own BIN"
                            checked={formikLogin.values.currently_have_access_to_a_bin === "Yes, we have our own BIN"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="We are in the process of acquiring a BIN"
                            id="option31"
                            name="currently_have_access_to_a_bin"
                            value="We are in the process of acquiring a BIN"
                            checked={formikLogin.values.currently_have_access_to_a_bin === "We are in the process of acquiring a BIN"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, we do not have access to a BIN"
                            id="option32"
                            name="currently_have_access_to_a_bin"
                            value="No, we do not have access to a BIN"
                            checked={formikLogin.values.currently_have_access_to_a_bin === "No, we do not have access to a BIN"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Not sure yet"
                            id="option33"
                            name="currently_have_access_to_a_bin"
                            value="Not sure yet"
                            checked={formikLogin.values.currently_have_access_to_a_bin === "Not sure yet"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.currently_have_access_to_a_bin && touched.currently_have_access_to_a_bin && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.currently_have_access_to_a_bin}
                            </p>
                        )}
                    </>
                )}
                {step === 16 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Do you have any payment processors ?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="We need integration with third-party processors"
                            id="option30"
                            name="payment_processors"
                            value="We need integration with third-party processors"
                            checked={formikLogin.values.payment_processors === "We need integration with third-party processors"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="We have our own payment processor"
                            id="option31"
                            name="payment_processors"
                            value="We have our own payment processor"
                            checked={formikLogin.values.payment_processors === "We have our own payment processor"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="We are exploring options"
                            id="option32"
                            name="payment_processors"
                            value="We are exploring options"
                            checked={formikLogin.values.payment_processors === "We are exploring options"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Not sure yet"
                            id="option33"
                            name="payment_processors"
                            value="Not sure yet"
                            checked={formikLogin.values.payment_processors === "Not sure yet"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.payment_processors && touched.payment_processors && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.payment_processors}
                            </p>
                        )}
                    </>
                )}
                {step === 17 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">What is the expected monthly volume of cards ?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label=" Less than 1,000 cards"
                            id="option30"
                            name="transaction_volume"
                            value=" Less than 1,000 cards"
                            checked={formikLogin.values.transaction_volume === " Less than 1,000 cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="1,000 - 10,000 cards"
                            id="option31"
                            name="transaction_volume"
                            value="1,000 - 10,000 cards"
                            checked={formikLogin.values.transaction_volume === "1,000 - 10,000 cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="10,000 - 50,000 cards"
                            id="option32"
                            name="transaction_volume"
                            value="10,000 - 50,000 cards"
                            checked={formikLogin.values.transaction_volume === "10,000 - 50,000 cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="More than 50,000 cards"
                            id="option33"
                            name="transaction_volume"
                            value="More than 50,000 cards"
                            checked={formikLogin.values.transaction_volume === "More than 50,000 cards"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.transaction_volume && touched.transaction_volume && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.transaction_volume}
                            </p>
                        )}
                    </>
                )}
                {step === 18 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">When are you planning to launch this business?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label=" Within 1 month"
                            id="option30"
                            name="planning_to_launch"
                            value=" Within 1 month"
                            checked={formikLogin.values.planning_to_launch === " Within 1 month"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="1 to 3 months"
                            id="option31"
                            name="planning_to_launch"
                            value="1 to 3 months"
                            checked={formikLogin.values.planning_to_launch === "1 to 3 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="3–6 months"
                            id="option32"
                            name="planning_to_launch"
                            value="3–6 months"
                            checked={formikLogin.values.planning_to_launch === "3–6 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="More than 6 months"
                            id="option33"
                            name="planning_to_launch"
                            value="More than 6 months"
                            checked={formikLogin.values.planning_to_launch === "More than 6 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.planning_to_launch && touched.planning_to_launch && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.planning_to_launch}
                            </p>
                        )}
                    </>
                )}
                {/* step 13 call */}


                {/* IR */}
                {step === 8 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Are you currently operating International Remittance business ?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes"
                            id="option33"
                            name="currently_operating_ir"
                            value="Yes"
                            checked={formikLogin.values.currently_operating_ir === "Yes"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No"
                            id="option34"
                            name="currently_operating_ir"
                            value="No"
                            checked={formikLogin.values.currently_operating_ir === "No"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.currently_operating_ir && touched.currently_operating_ir && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.currently_operating_ir}
                            </p>
                        )}
                    </>
                )}
                {step === 9 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">In which countries are you operating International remittance business ?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Group className={errors.operate_country && touched.operate_country ? "mb-3 was-validated" : "mb-3"}>
                            {/* <Form.Label>
                            In which country are you planning to operate eWallet business ? <em className='text-danger'>*</em>
                          </Form.Label> */}
                            {/* <Form.Select
                            aria-label="License"
                            name='operate_country'
                            size='lg'
                            value={formikLogin.values.operate_country}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                            required
                          >
                            <option value=''>Please select country</option>
                            <option value='India'>India</option>
                            <option value='America'>America</option>
                            <option value='Africa'>Africa</option>
                          </Form.Select> */}

                            <Select
                                required
                                options={options}
                                value={options.find(option => option.value === formikLogin.values.operate_country)}
                                onChange={changeHandler}
                                placeholder="Select country"
                            />

                        </Form.Group>
                    </>
                )}
                {step === 10 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">In which countries are you planning to operate new corridors  ?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Group className={errors.operate_new_corridors_country && touched.operate_new_corridors_country ? "mb-3 was-validated" : "mb-3"}>
                            {/* <Form.Label>
                            In which country are you planning to operate eWallet business ? <em className='text-danger'>*</em>
                          </Form.Label> */}
                            {/* <Form.Select
                            aria-label="License"
                            name='operate_new_corridors_country'
                            size='lg'
                            value={formikLogin.values.operate_new_corridors_country}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                            required
                          >
                            <option value=''>Please select country</option>
                            <option value='India'>India</option>
                            <option value='America'>America</option>
                            <option value='Africa'>Africa</option>
                          </Form.Select> */}
                            <Select
                                required
                                options={options}
                                value={options.find(option => option.value === formikLogin.values.operate_new_corridors_country)}
                                onChange={changeHandlercorridor}
                                placeholder="Select country"
                            />
                        </Form.Group>
                    </>
                )}
                {step === 11 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">What are the issues/problems with the existing solution ?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Complicated user interface"
                            name="facing_issues"
                            id="option3"
                            value="Complicated user interface"
                            checked={formikLogin.values.facing_issues === "Complicated user interface"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Slow processing times"
                            name="facing_issues"
                            id="option4"
                            value="Slow processing times"
                            checked={formikLogin.values.facing_issues === "Slow processing times"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Compliance challenges"
                            name="facing_issues"
                            id="option5"
                            value="Compliance challenges"
                            checked={formikLogin.values.facing_issues === "Compliance challenges"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Limited features"
                            name="facing_issues"
                            id="option6"
                            value="Limited features"
                            checked={formikLogin.values.facing_issues === "Limited features"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Poor customer support"
                            name="facing_issues"
                            id="option7"
                            value="Poor customer support"
                            checked={formikLogin.values.facing_issues === "Poor customer support"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label=" Security concerns"
                            name="facing_issues"
                            id="option8"
                            value=" Security concerns"
                            checked={formikLogin.values.facing_issues === " Security concerns"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Integration problems"
                            name="facing_issues"
                            id="option9"
                            value="Integration problems"
                            checked={formikLogin.values.facing_issues === "Integration problems"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Geographical restrictions"
                            name="facing_issues"
                            id="option10"
                            value="Geographical restrictions"
                            checked={formikLogin.values.facing_issues === "Geographical restrictions"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Technical glitches"
                            name="facing_issues"
                            id="option11"
                            value="Technical glitches"
                            checked={formikLogin.values.facing_issues === "Technical glitches"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.facing_issues && touched.facing_issues && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.facing_issues}
                            </p>
                        )}
                    </>
                )}
                {step === 15 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Do you currently hold any licenses for offering remittance services, and if so, what type of license(s) do you hold?</h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, we have a Money Transfer Operator (MTO) License"
                            name="financial_service_license"
                            id="option1"
                            value="Yes, we have a Money Transfer Operator (MTO) License"
                            checked={formikLogin.values.financial_service_license === "Yes, we have a Money Transfer Operator (MTO) License"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, we have a Payment Institution (PI) License"
                            name="financial_service_license"
                            id="option2"
                            value="Yes, we have a Payment Institution (PI) License"
                            checked={formikLogin.values.financial_service_license === "Yes, we have a Payment Institution (PI) License"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, we have an Electronic Money Institution (EMI) License"
                            name="financial_service_license"
                            id="option3"
                            value="Yes, we have an Electronic Money Institution (EMI) License"
                            checked={formikLogin.values.financial_service_license === "Yes, we have an Electronic Money Institution (EMI) License"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, we have other licenses (Please specify)"
                            name="financial_service_license"
                            id="option4"
                            value="Yes, we have other licenses (Please specify)"
                            checked={formikLogin.values.financial_service_license === "Yes, we have other licenses (Please specify)"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {formikLogin.values.financial_service_license === "Yes, we have other licenses (Please specify)" && (
                            <Form.Group as={Col} className={errors.other_reason_cross_border && touched.other_reason_cross_border ? "mb-3 was-validated" : "mb-3"}>
                                <Form.Control
                                    type="text"
                                    name="other_reason_cross_border"
                                    value={formikLogin.values.other_reason_cross_border}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                    placeholder="Please enter your reason"
                                    size="lg"
                                    // isInvalid={formikLogin.touched.other_reason_cross_border && !!formikLogin.errors.other_reason_cross_border}
                                    required

                                />
                            </Form.Group>
                        )}
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, we are in the process of acquiring licenses"
                            name="financial_service_license"
                            id="option5"
                            value="No, we are in the process of acquiring licenses"
                            checked={formikLogin.values.financial_service_license === "No, we are in the process of acquiring licenses"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, we need guidance on obtaining licenses"
                            name="financial_service_license"
                            id="option6"
                            value="No, we need guidance on obtaining licenses"
                            checked={formikLogin.values.financial_service_license === "No, we need guidance on obtaining licenses"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.financial_service_license && touched.financial_service_license && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.financial_service_license}
                            </p>
                        )}
                    </>
                )}


                {/* Merchant Solution */}

                {step === 19 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Does your company hold a merchant service or any similar required license?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label=" Yes, I have a merchant license"
                            id="option30"
                            name="financial_service_license"
                            value=" Yes, I have a merchant license"
                            checked={formikLogin.values.financial_service_license === " Yes, I have a merchant license"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, but I plan to obtain one"
                            id="option31"
                            name="financial_service_license"
                            value="No, but I plan to obtain one"
                            checked={formikLogin.values.financial_service_license === "No, but I plan to obtain one"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, and I do not plan to obtain one"
                            id="option32"
                            name="financial_service_license"
                            value="No, and I do not plan to obtain one"
                            checked={formikLogin.values.financial_service_license === "No, and I do not plan to obtain one"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.financial_service_license && touched.financial_service_license && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.financial_service_license}
                            </p>
                        )}
                    </>
                )}

                {step === 20 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Do you currently have a payment processor for your merchant acquiring solution?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, I have a processor selected"
                            id="option30"
                            name="payment_processors"
                            value="Yes, I have a processor selected"
                            checked={formikLogin.values.payment_processors === "Yes, I have a processor selected"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, but I am researching options"
                            id="option31"
                            name="payment_processors"
                            value="No, but I am researching options"
                            checked={formikLogin.values.payment_processors === "No, but I am researching options"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, I need assistance finding a processor"
                            id="option32"
                            name="payment_processors"
                            value="No, I need assistance finding a processor"
                            checked={formikLogin.values.payment_processors === "No, I need assistance finding a processor"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Not applicable (not considering a processor)"
                            id="option33"
                            name="payment_processors"
                            value="Not applicable (not considering a processor)"
                            checked={formikLogin.values.payment_processors === "Not applicable (not considering a processor)"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.payment_processors && touched.payment_processors && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.payment_processors}
                            </p>
                        )}
                    </>
                )}
                {/*  */}
                {step === 21 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">What type of business are you looking to establish in the merchant acquiring industry?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Retail payment processing"
                            id="option30"
                            name="type_of_business"
                            value="Retail payment processing"
                            checked={formikLogin.values.type_of_business === "Retail payment processing"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="E-commerce payment solutions"
                            id="option31"
                            name="type_of_business"
                            value="E-commerce payment solutions"
                            checked={formikLogin.values.type_of_business === "E-commerce payment solutions"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Service-based merchant acquiring"
                            id="option32"
                            name="type_of_business"
                            value="Service-based merchant acquiring"
                            checked={formikLogin.values.type_of_business === "Service-based merchant acquiring"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Other (please specify)"
                            id="option33"
                            name="type_of_business"
                            value="Other (please specify)"
                            checked={formikLogin.values.type_of_business === "Other (please specify)"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {formikLogin.values.type_of_business === "Other (please specify)" && (
                            <Form.Group as={Col} className={errors.other_reason_type_of_business && touched.other_reason_type_of_business ? "mb-3 was-validated" : "mb-3"}>
                                <Form.Control
                                    type="text"
                                    name="other_reason_type_of_business"
                                    value={formikLogin.values.other_reason_type_of_business}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                    placeholder="Please enter your reason"
                                    size="lg"
                                    // isInvalid={formikLogin.touched.other_reason_type_of_business && !!formikLogin.errors.other_reason_type_of_business}
                                    required

                                />
                            </Form.Group>
                        )}
                        {errors.type_of_business && touched.type_of_business && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.type_of_business}
                            </p>
                        )}

                    </>
                )}

                {step === 22 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">Are you planning to offer merchants mPOS (mobile point of sale) solutions, and do you have a vendor in mind for the mPOS hardware and software?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, I plan to offer mPOS and have a vendor selected"
                            id="option30"
                            name="planning_to_offer_merchants_mpos"
                            value="Yes, I plan to offer mPOS and have a vendor selected"
                            checked={formikLogin.values.planning_to_offer_merchants_mpos === "Yes, I plan to offer mPOS and have a vendor selected"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Yes, I plan to offer mPOS but need assistance finding a vendor"
                            id="option31"
                            name="planning_to_offer_merchants_mpos"
                            value="Yes, I plan to offer mPOS but need assistance finding a vendor"
                            checked={formikLogin.values.planning_to_offer_merchants_mpos === "Yes, I plan to offer mPOS but need assistance finding a vendor"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="No, I do not plan to offer mPOS"
                            id="option32"
                            name="planning_to_offer_merchants_mpos"
                            value="No, I do not plan to offer mPOS"
                            checked={formikLogin.values.planning_to_offer_merchants_mpos === "No, I do not plan to offer mPOS"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="I’m unsure at this time"
                            id="option33"
                            name="planning_to_offer_merchants_mpos"
                            value="I’m unsure at this time"
                            checked={formikLogin.values.planning_to_offer_merchants_mpos === "I’m unsure at this time"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.planning_to_offer_merchants_mpos && touched.planning_to_offer_merchants_mpos && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.planning_to_offer_merchants_mpos}
                            </p>
                        )}
                    </>
                )}

                {step === 23 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">What is your expected monthly transaction volume as a merchant acquirer?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Less than 1,00,000"
                            id="option30"
                            name="transaction_volume"
                            value="Less than 1,00,000"
                            checked={formikLogin.values.transaction_volume === "Less than 1,00,000"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="1,00,000 - 5,00,000"
                            id="option31"
                            name="transaction_volume"
                            value="1,00,000 - 5,00,000"
                            checked={formikLogin.values.transaction_volume === "1,00,000 - 5,00,000"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="5,00,000 - 10,00,000"
                            id="option32"
                            name="transaction_volume"
                            value="5,00,000 - 10,00,000"
                            checked={formikLogin.values.transaction_volume === "5,00,000 - 10,00,000"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="More than 10,00,000"
                            id="option33"
                            name="transaction_volume"
                            value="More than 10,00,000"
                            checked={formikLogin.values.transaction_volume === "More than 10,00,000"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.transaction_volume && touched.transaction_volume && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.transaction_volume}
                            </p>
                        )}
                    </>
                )}
                {step === 24 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">When are you planning to launch merchant acquiring solution?
                            </h3>
                            <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                        </div>
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="Within the next month"
                            id="option30"
                            name="planning_to_launch"
                            value="Within the next month"
                            checked={formikLogin.values.planning_to_launch === "Within the next month"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="1 to 3 months"
                            id="option31"
                            name="planning_to_launch"
                            value="1 to 3 months"
                            checked={formikLogin.values.planning_to_launch === "1 to 3 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />

                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="3 to 6 months"
                            id="option32"
                            name="planning_to_launch"
                            value="3 to 6 months"
                            checked={formikLogin.values.planning_to_launch === "3 to 6 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        <Form.Check
                            className="mb-2"
                            type="radio"
                            label="More than 6 months"
                            id="option33"
                            name="planning_to_launch"
                            value="More than 6 months"
                            checked={formikLogin.values.planning_to_launch === "More than 6 months"}
                            onChange={formikLogin.handleChange}
                            onBlur={formikLogin.handleBlur}
                        />
                        {errors.planning_to_launch && touched.planning_to_launch && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.planning_to_launch}
                            </p>
                        )}
                    </>
                )}
                {step === 25 && (
                    <>
                        <div className="mb-4">
                            <h3 className="mb-3">What issues or problems are you experiencing with your current payment processing solution?</h3>
                            <p className="mb-0">We guarantee to get back to you within a business day.</p>
                        </div>

                        {[
                            "Complicated user interface",
                            "Slow processing times",
                            "Lack of customer support",
                            "Limited payment options",
                            "Integration challenges",
                            "Not applicable (no current solution)",
                            "Other (please specify)"
                        ].map((option, index) => (
                            <Form.Check
                                key={index}
                                className="mb-2 form-checkbox"
                                type="checkbox"
                                label={option}
                                id={`option${30 + index}`}
                                name="facing_merchant_issues"
                                value={option}
                                checked={formikLogin.values.facing_merchant_issues.includes(option)}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    let currentValues = formikLogin.values.facing_merchant_issues || [];

                                    if (currentValues.includes(value)) {
                                        // Remove if already selected
                                        currentValues = currentValues.filter((item) => item !== value);

                                        // If "Other (please specify)" is deselected, clear input and state
                                        if (value === "Other (please specify)") {
                                            formikLogin.setFieldValue("other_reason_facing_merchant_issues", "");
                                            setIsOtherSelected(false);
                                        }
                                    } else {
                                        // Add if not selected
                                        currentValues = [...currentValues, value];

                                        // If "Other (please specify)" is selected, set state to keep input open
                                        if (value === "Other (please specify)") {
                                            setIsOtherSelected(true);
                                        }
                                    }

                                    // Update the selected values
                                    formikLogin.setFieldValue("facing_merchant_issues", currentValues);
                                }}
                                onBlur={formikLogin.handleBlur}
                            />
                        ))}

                        {/* Conditional text input for "Other (please specify)" */}
                        {formikLogin.values.facing_merchant_issues.includes("Other (please specify)") && (
                            <Form.Group as={Col} className={errors.other_reason_facing_merchant_issues && touched.other_reason_facing_merchant_issues ? "mb-3 was-validated" : "mb-3"}>
                                <Form.Control
                                    type="text"
                                    name="other_reason_facing_merchant_issues"
                                    value={formikLogin.values.other_reason_facing_merchant_issues}
                                    onChange={formikLogin.handleChange}
                                    onBlur={formikLogin.handleBlur}
                                    placeholder="Please enter your reason"
                                    size="lg"
                                    required
                                />
                                {/* {errors.other_reason_facing_merchant_issues && touched.other_reason_facing_merchant_issues && (
                                    <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                        {errors.other_reason_facing_merchant_issues}
                                    </p>
                                )} */}
                            </Form.Group>
                        )}

                        {/* Validation error message */}
                        {errors.facing_merchant_issues && touched.facing_merchant_issues && (
                            <p className="form-text text-danger mt-2 mb-0 font-size-14">
                                {errors.facing_merchant_issues}
                            </p>
                        )}
                    </>
                    // <>
                    //     <div className="mb-4">
                    //         <h3 className="mb-3">What issues or problems are you experiencing with your current payment processing solution?
                    //         </h3>
                    //         <p className="mb-0"> We guarantee to get back to you within a business day.</p>
                    //     </div>

                    //     <Form.Check
                    //         className="mb-2"
                    //         type="checkbox"
                    //         label="Complicated user interface"
                    //         id="option30"
                    //         name="facing_merchant_issues"
                    //         value="Complicated user interface"
                    //         checked={formikLogin.values.facing_merchant_issues === "Complicated user interface"}
                    //         onChange={formikLogin.handleChange}
                    //         onBlur={formikLogin.handleBlur}
                    //     />
                    //     <Form.Check
                    //         className="mb-2"
                    //         type="checkbox"
                    //         label="Slow processing times"
                    //         id="option31"
                    //         name="facing_merchant_issues"
                    //         value="Slow processing times"
                    //         checked={formikLogin.values.facing_merchant_issues === "Slow processing times"}
                    //         onChange={formikLogin.handleChange}
                    //         onBlur={formikLogin.handleBlur}
                    //     />
                    //     <Form.Check
                    //         className="mb-2"
                    //         type="checkbox"
                    //         label="Lack of customer support"
                    //         id="option32"
                    //         name="facing_merchant_issues"
                    //         value="Lack of customer support"
                    //         checked={formikLogin.values.facing_merchant_issues === "Lack of customer support"}
                    //         onChange={formikLogin.handleChange}
                    //         onBlur={formikLogin.handleBlur}
                    //     />
                    //     <Form.Check
                    //         className="mb-2"
                    //         type="checkbox"
                    //         label="Limited payment options"
                    //         id="option33"
                    //         name="facing_merchant_issues"
                    //         value="Limited payment options"
                    //         checked={formikLogin.values.facing_merchant_issues === "Limited payment options"}
                    //         onChange={formikLogin.handleChange}
                    //         onBlur={formikLogin.handleBlur}
                    //     />
                    //     <Form.Check
                    //         className="mb-2"
                    //         type="checkbox"
                    //         label="Integration challenges"
                    //         id="option34"
                    //         name="facing_merchant_issues"
                    //         value="Integration challenges"
                    //         checked={formikLogin.values.facing_merchant_issues === "Integration challenges"}
                    //         onChange={formikLogin.handleChange}
                    //         onBlur={formikLogin.handleBlur}
                    //     />
                    //     <Form.Check
                    //         className="mb-2"
                    //         type="checkbox"
                    //         label="Other (please specify)"
                    //         id="option35"
                    //         name="facing_merchant_issues"
                    //         value="Other (please specify)"
                    //         checked={formikLogin.values.facing_merchant_issues === "Other (please specify)"}
                    //         onChange={formikLogin.handleChange}
                    //         onBlur={formikLogin.handleBlur}
                    //     />
                    //     {formikLogin.values.facing_merchant_issues === "Other (please specify)" && (
                    //         <Form.Group as={Col} className={errors.other_reason_facing_merchant_issues && touched.other_reason_facing_merchant_issues ? "mb-3 was-validated" : "mb-3"}>
                    //             <Form.Control
                    //                 type="text"
                    //                 name="other_reason_facing_merchant_issues"
                    //                 value={formikLogin.values.other_reason_facing_merchant_issues}
                    //                 onChange={formikLogin.handleChange}
                    //                 onBlur={formikLogin.handleBlur}
                    //                 placeholder="Please enter your reason"
                    //                 size="lg"
                    //                 // isInvalid={formikLogin.touched.other_reason_facing_merchant_issues && !!formikLogin.errors.other_reason_facing_merchant_issues}
                    //                 required

                    //             />
                    //         </Form.Group>
                    //     )}
                    //     <Form.Check
                    //         className="mb-2"
                    //         type="checkbox"
                    //         label="Not applicable (no current solution)"
                    //         id="option36"
                    //         name="facing_merchant_issues"
                    //         value="Not applicable (no current solution)"
                    //         checked={formikLogin.values.facing_merchant_issues === "Not applicable (no current solution)"}
                    //         onChange={formikLogin.handleChange}
                    //         onBlur={formikLogin.handleBlur}
                    //     />
                    //     {errors.facing_merchant_issues && touched.facing_merchant_issues && (
                    //         <p className="form-text text-danger mt-2 mb-0 font-size-14">
                    //             {errors.facing_merchant_issues}
                    //         </p>
                    //     )}
                    // </>
                )}


                <div className='form-action text-center d-sm-flex align-items-center '>
                    {
                        (step === 1) && (
                            <p className='text-danger mb-0 me-auto font-size-14'><i>* All mark field is required.</i></p>
                        )
                    }
                    <Button
                        type='button'
                        onClick={async () => {

                            await formikLogin.setTouched({
                                full_name: true,
                                email: true,
                                phone_no: true,
                                company_name: true,
                                description: true,
                                reason: true,
                                // industry: true,
                                // license: true,
                                financial_service_license: (step === 2 || step === 15 || step === 5 || step === 19) ? true : false,
                                operate_country: (step === 3 || step === 9) ? true : false,
                                card_solution_type: step === 4 ? true : false,
                                // card_issuing: step === 5 ? true : false,
                                other_reason: step === 6 ? true : false,
                                other_reason_type_of_business: step === 21 ? true : false,
                                other_reason_cross_border: step === 15 ? true : false,
                                other_reason_facing_merchant_issues: step === 25 ? true : false,
                                describes_your_organization: step === 6 ? true : false,
                                // other_reason:step === 6 ? true : false,
                                currently_have_access_to_a_bin: step === 7 ? true : false,
                                currently_operating_ir: step === 8 ? true : false,
                                // transaction: step === 9 ? true : false,
                                // existing_software: step === 10 ? true : false,
                                // current_software: step === 11 ? true : false,
                                currently_operating_ewallet: step === 12 ? true : false,
                                facing_issues_ewallet: step === 12 ? true : false,
                                // problems_solution: (step === 12 && formikLogin.values.operating === "Yes") ? true : false,
                                planning_to_launch: (step === 13 || step === 18 || step === 24) ? true : false,
                                transaction_volume: (step === 14 || step === 17 || step === 23) ? true : false,
                                // ir_country: step === 9 ? true : false,
                                operate_new_corridors_country: step === 10 ? true : false,
                                facing_issues: step === 11 ? true : false,
                                // remittance_services: step === 15 ? true : false,
                                // monthly_card: step === 17 ? true : false,
                                // planning_to_launch: step === 18 ? true : false,
                                payment_processors: (step === 16 || step === 20) ? true : false,

                                // Merchant Solution
                                // merchant_requirelicense: step === 19 ? true : false,
                                // merchant_acquiringsolution: step === 20 ? true : false,
                                type_of_business: step === 21 ? true : false,
                                planning_to_offer_merchants_mpos: step === 22 ? true : false,
                                // merchant_expectedtransaction: step === 23 ? true : false,
                                // merchant_launch_plan: step === 24 ? true : false,
                                facing_merchant_issues: step === 25 ? true : false,

                            });
                            const errors = await formikLogin.validateForm();
                            if (Object.keys(errors).length === 0) {
                                handleStepTransition();
                            }
                        }
                        }
                        disabled={disable}
                        variant=''
                        size='lg'
                        className='btn-primary-theme mt-2 ms-auto'
                    >
                        <span>
                            {isLoading
                                ? 'Sending...'
                                : (step === 1 &&
                                    (formikLogin.values.reason === "Mobile Money / eWallet Development" ||
                                        formikLogin.values.reason === "Prepaid Cards" ||
                                        formikLogin.values.reason === "Cross border Payment system" || formikLogin.values.reason === "Merchant Solution")) ||
                                    step === 2 ||
                                    step === 3 ||
                                    step === 4 ||
                                    step === 5 ||
                                    step === 6 ||
                                    step === 8 ||
                                    step === 7 ||
                                    step === 9 ||
                                    step === 10 ||
                                    step === 11 ||
                                    step === 12 ||
                                    step === 13 ||
                                    step === 15 ||
                                    step === 16 ||
                                    step === 17 ||
                                    step === 19 ||
                                    step === 20 ||
                                    step === 21 ||
                                    step === 22 ||
                                    step === 23 ||
                                    step === 24
                                    ? 'Next'
                                    : 'Send Now'}
                        </span>
                    </Button>
                </div>
                {successMsg ? (
                    <div className='alert alert-success mt-4'>
                        {' '}
                        {successMsg}{' '}
                    </div>
                ) : null}
            </Form >
        </>
    );
}

export default ContactUsForm
